/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import { ShopState } from "../shop-state";
import { DECREASE_SHOP_ITEM_AMOUNT, GET_ALL_SHOP_ITEMS_SUCCESS, REMOVE_SHOP_ITEM_FROM_CART, ADD_SHOP_ITEM_TO_CART } from "../actions/shop.actions";
import { ShopItem } from "src/app/core/models/entites/shop/shopItem";
import { SubmitOrderRequest } from "src/app/core/models/requests/shop/submitOrderRequest";


const getShopFeatureState = createFeatureSelector<ShopState>("shopItems");

export const getAllShopItems = createSelector(
    getShopFeatureState,
    (state: ShopState) => state.allShopItems
);

export const getAllCartShopItems = createSelector(
    selectCartShopItemsInSessionStorageValue,
    (cartShopItems: ShopItem[]) => cartShopItems
);
export const getSubmitOrderRequest = createSelector(
    selectSubmitOrderReqeustInSessionStorageValue,
    (submitOrderRequest: SubmitOrderRequest) => submitOrderRequest
);

export const getTotalCartPrice = createSelector(
    selectCartShopItemsInSessionStorageValue,
    cartShopItems => {
        let totalCartPrice = 0;
        cartShopItems.forEach((cartShopItem: ShopItem) => {
            totalCartPrice += Number(cartShopItem.price) * Number(cartShopItem.amount);
        });
        return totalCartPrice;
    }
);

export const getCartItemLimit = (cartItem: ShopItem, cartItemAmount: number) => createSelector(
    selectCartShopItemsInSessionStorageValue,
    cartShopItems => {
        let totalAmount = 0;
        cartShopItems.forEach((shopItem: ShopItem) => {
            if (shopItem.name === cartItem.name)
                totalAmount += Number(shopItem.amount);
        });
        if (totalAmount == 0 || totalAmount - cartItemAmount <= 0) {
            cartItem.maxNumberOfPurchases;
        }
        return cartItem.maxNumberOfPurchases! - totalAmount;
    }
);

export const getShopItemsCount = createSelector(
    selectCartShopItemsInSessionStorageValue,
    cartShopItems => {
        let totalCount = 0;
        cartShopItems.forEach((shopItem: ShopItem) => {
            totalCount += Number(shopItem.amount);
        });
        return totalCount;
    }
);

const initialState: ShopState = {
    allShopItems: [],
    shopItemsInCart: [],
    selectedShopItem: undefined
};

export const shopReducer = createReducer<ShopState>(
    initialState,
    on(GET_ALL_SHOP_ITEMS_SUCCESS, (state, { allShopItems }): ShopState => {
        return {
            ...state,
            allShopItems: allShopItems,
        };
    }),
    on(ADD_SHOP_ITEM_TO_CART, (state, { shopItemToAdd, shopItemAmount }): ShopState => {
        let shopItemsInCart = selectCartShopItemsInSessionStorageValue();

        if (!shopItemsInCart.some((shopItemInCart) => areShopItemEquals(shopItemInCart, shopItemToAdd))) {

            const shopItemCopy = { ...shopItemToAdd };

            shopItemCopy.amount = shopItemAmount;
            shopItemsInCart = [...shopItemsInCart, shopItemCopy] as ShopItem[];

            localStorage.setItem("shopCart", JSON.stringify(shopItemsInCart));
            return { ...state };
        }
        else {
            shopItemsInCart = [...shopItemsInCart.map((shopItem: ShopItem) => ({
                ...shopItem,
                amount: areShopItemEquals(shopItem, shopItemToAdd)
                    ? shopItem.amount + shopItemAmount : shopItem.amount
            }))] as ShopItem[];
        }
        localStorage.setItem("shopCart", JSON.stringify(shopItemsInCart));
        return { ...state };
    }),
    on(REMOVE_SHOP_ITEM_FROM_CART, (state, { shopItemToRemoveIndex }): ShopState => {
        let shopItemsInCart = selectCartShopItemsInSessionStorageValue();

        shopItemsInCart = [...shopItemsInCart.slice(0, shopItemToRemoveIndex),
        ...shopItemsInCart.slice(shopItemToRemoveIndex + 1)];

        localStorage.setItem("shopCart", JSON.stringify(shopItemsInCart));
        return { ...state };
    }),
    on(DECREASE_SHOP_ITEM_AMOUNT, (state, { shopItemToRemove }): ShopState => {
        let shopItemsInCart = selectCartShopItemsInSessionStorageValue();
        shopItemsInCart = [...shopItemsInCart.map(
            ((shopItem: ShopItem) => ({
                ...shopItem,
                amount: areShopItemEquals(shopItem, shopItemToRemove) ? shopItem.amount - 1 : shopItem.amount
            }) as ShopItem)
        )];
        localStorage.setItem("shopCart", JSON.stringify(shopItemsInCart));
        return { ...state };
    }),
);

function selectCartShopItemsInSessionStorageValue(): ShopItem[] {
    const cartItems = JSON.parse(localStorage!.getItem("shopCart")!) as ShopItem[];
    return cartItems == null ? [] : cartItems;
}

function areShopItemEquals(shopItem: ShopItem, shopItemToCompare: ShopItem) {
    let areAttributeValuesEqual = true;
    shopItem.selectedShopItemsAttributes.forEach(function (value) {
        if (!shopItemToCompare.selectedShopItemsAttributes.some(x => x.attributeValue.attributeValue_ID === value.attributeValue.attributeValue_ID)) {
            areAttributeValuesEqual = false;
        }
    });
    return shopItem.name === shopItemToCompare.name && areAttributeValuesEqual;
}

function selectSubmitOrderReqeustInSessionStorageValue(): SubmitOrderRequest {
    const submitOrderRequest = JSON.parse(localStorage!.getItem("submitOrderRequest")!) as SubmitOrderRequest;
    return submitOrderRequest;
}